var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSunDm = function SvgSunDm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1C2243",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.907 7a3.907 3.907 0 1 1-7.814 0 3.907 3.907 0 0 1 7.814 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.212 0c.386 0 .7.219.7.488v.652c0 .27-.314.488-.7.488-.387 0-.7-.219-.7-.488V.488c0-.27.313-.488.7-.488ZM2.07 2.07a.555.555 0 0 1 .784 0l.29.29a.555.555 0 0 1-.784.785l-.29-.29a.555.555 0 0 1 0-.785Zm10.028 0a.555.555 0 0 1 0 .784l-.291.29a.555.555 0 0 1-.784-.784l.29-.29a.555.555 0 0 1 .785 0ZM0 7.212c0-.387.219-.7.488-.7h.652c.27 0 .488.313.488.7 0 .386-.219.7-.488.7H.488c-.27 0-.488-.314-.488-.7Zm12.372 0c0-.387.219-.7.488-.7h.652c.27 0 .488.313.488.7 0 .386-.219.7-.488.7h-.652c-.27 0-.488-.314-.488-.7Zm-1.35 3.81a.555.555 0 0 1 .785 0l.29.291a.555.555 0 1 1-.784.785l-.29-.291a.555.555 0 0 1 0-.784Zm-7.877 0a.555.555 0 0 1 0 .785l-.29.29a.555.555 0 1 1-.785-.784l.29-.29a.555.555 0 0 1 .785 0Zm4.067 1.35c.386 0 .7.219.7.488v.652c0 .27-.314.488-.7.488-.387 0-.7-.219-.7-.488v-.652c0-.27.313-.488.7-.488Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSunDm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun-dm.ea7e2497.svg";
export { ForwardRef as ReactComponent };